import csdd_logo from 'assets/csdd_images/csdd-logo.png';
import MKButton from 'components/MKButton';
import MKTypography from 'components/MKTypography';
import { Link } from 'react-router-dom';

const HomeNavBar = () => {
  return (
    <>
      <nav className='navbar navbar-expand-lg bg-white'>
        <div className='container-fluid'>
          <Link className='navbar-brand' to='/'>
            <img src={csdd_logo} alt='CSDD Logo' width='60' height='60' />
          </Link>
          <button
            className='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>
          <div
            className='collapse navbar-collapse justify-content-end'
            id='navbarSupportedContent'
          >
            <ul className='navbar-nav'>
              <li className='nav-item'>
                <Link to='/' className='me-4 nav-link' aria-current='page'>
                  <MKTypography
                    textGradient
                    variant='button'
                    fontWeight='medium'
                    textTransform='capitalize'
                    color={'error'}
                  >
                    Home
                  </MKTypography>
                </Link>
              </li>
              <li className='nav-item dropdown'>
                <div
                  className='me-4 nav-link dropdown-toggle'
                  role='button'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  <MKTypography
                    textGradient
                    variant='button'
                    fontWeight='medium'
                    textTransform='capitalize'
                    color={'error'}
                  >
                    About Us
                  </MKTypography>
                </div>
                <ul className='px-3 pt-3 dropdown-menu'>
                  <li>
                    <Link className='dropdown-item' to='/about-us'>
                      <MKTypography
                        textGradient
                        variant='button'
                        fontWeight='regular'
                        textTransform='capitalize'
                        color={'warning'}
                      >
                        Who we are
                      </MKTypography>
                      <MKTypography display='block' variant='button'>
                        Get to know us
                      </MKTypography>
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' to='/leadership'>
                      <MKTypography
                        textGradient
                        variant='button'
                        fontWeight='regular'
                        textTransform='capitalize'
                        color={'warning'}
                      >
                        Leadership
                      </MKTypography>
                      <MKTypography display='block' variant='button'>
                        Learn more about the executive members
                      </MKTypography>
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' to='/partners'>
                      <MKTypography
                        textGradient
                        variant='button'
                        fontWeight='regular'
                        textTransform='capitalize'
                        color={'warning'}
                      >
                        Partners
                      </MKTypography>
                      <MKTypography display='block' variant='button'>
                        See all our partners
                      </MKTypography>
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' to='/contact-us'>
                      <MKTypography
                        textGradient
                        variant='button'
                        fontWeight='regular'
                        textTransform='capitalize'
                        color={'warning'}
                      >
                        Contact Us
                      </MKTypography>
                      <MKTypography display='block' variant='button'>
                        Send us a message
                      </MKTypography>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className='nav-item dropdown'>
                <div
                  className='me-4 nav-link dropdown-toggle'
                  role='button'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  <MKTypography
                    textGradient
                    variant='button'
                    fontWeight='medium'
                    textTransform='capitalize'
                    color={'error'}
                  >
                    News
                  </MKTypography>
                </div>
                <ul className='px-3 pt-2 dropdown-menu'>
                  <li>
                    <Link className='dropdown-item' to='/news'>
                      <MKTypography
                        textGradient
                        variant='button'
                        fontWeight='regular'
                        textTransform='capitalize'
                        color={'warning'}
                      >
                        Latest News
                      </MKTypography>
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' to='/industry-updates'>
                      <MKTypography
                        textGradient
                        variant='button'
                        fontWeight='regular'
                        textTransform='capitalize'
                        color={'warning'}
                      >
                        Industry Updates
                      </MKTypography>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className='nav-item dropdown'>
                <div
                  className='me-4 nav-link dropdown-toggle'
                  role='button'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  <MKTypography
                    textGradient
                    variant='button'
                    fontWeight='medium'
                    textTransform='capitalize'
                    color={'error'}
                  >
                    Events & Gallery
                  </MKTypography>
                </div>
                <ul className='px-3 pt-2 dropdown-menu'>
                  <li>
                    <Link className='dropdown-item' to='/events'>
                      <MKTypography
                        textGradient
                        variant='button'
                        fontWeight='regular'
                        textTransform='capitalize'
                        color={'warning'}
                      >
                        Events
                      </MKTypography>
                    </Link>
                  </li>
                  <li>
                    <Link className='dropdown-item' to='/gallery'>
                      <MKTypography
                        textGradient
                        variant='button'
                        fontWeight='regular'
                        textTransform='capitalize'
                        color={'warning'}
                      >
                        Photo Gallery
                      </MKTypography>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
            <MKButton
              variant='contained'
              color='warning'
              component={Link}
              to='/contact-us'
              size='small'
            >
              work with us
            </MKButton>
          </div>
        </div>
      </nav>
    </>
  );
};
export default HomeNavBar;
